import { Colors } from '@sigma-frontend-libs/commons'

import { components, icons, numberToPxOrString, services } from '@/utils'

import textOverflow from '@/components/text/overflow'

function renderVoiceBars(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__voice-track__bars`
    },
    this.voiceBars.map((height, index) => {
      return h(
        'div',
        {
          class: `${services.sendings}-preview__voice-track__bar`,
          style: {
            height: numberToPxOrString(height)
          },
          key: index
        }
      )
    })
  )
}
function renderVoiceTrack(h) {
  return h(
    'div',
    {
      class: [
        `${services.sendings}-preview__voice-track`,
        `${services.sendings}-preview__voice-track--${this.value.type}`
      ],
      ref: 'track'

    },
    [ renderVoiceBars.call(this, h) ]
  )
}
function renderVoiceTime(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__voice-info-time`
    },
    [ this.time ]
  )
}
function renderSendername(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__voice-info-sender`
    },
    [
      h(
        textOverflow,
        {
          props: {
            value: this.value.payload?.sender
          }
        }
      )
    ]
  )
}
function renderVoiceInfo(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__voice-info`
    },
    [
      renderSendername.call(this, h),
      renderVoiceTime.call(this, h)
    ]
  )
}
function renderCallButton(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__voice-button`
    },
    [
      h(
        components.icon,
        {
          props: {
            value: icons.call_end,
            color: Colors.white
          }
        }
      )
    ]
  )
}
export default function(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-preview__voice`
    },
    [
      renderVoiceTrack.call(this, h),
      renderVoiceInfo.call(this, h),
      renderCallButton.call(this, h)
    ]
  )
}
